import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/home.vue';
import Serve from '@/components/serve.vue';

Vue.use(Router);

const routes = [
    {
    path: '/',
    redirect: process.env.VUE_APP_DEFAULT_PAGE === 'serve' ? '/serve' : '/home'
    },
    {
        path: '/home',
        name: 'Home',
        component: Home
    },
    {
        path: '/serve',
        name: 'Serve',
        component: Serve
    }
];

const router = new Router({
  mode: 'history',
  routes
});

router.beforeEach((to, from, next) => {
if (process.env.VUE_APP_DEFAULT_PAGE === 'serve') {
    // 阻止访问
    if (to.path === '/home') {
    next('/serve');
    } else {
    next();
    }
} else {
    next();
}
});

export default router;
